import { createContext } from "react";

export const DraggableItemsContext = createContext<Record<string, string[]>>({});
